import { GridColDef } from "@mui/x-data-grid-premium";
import { renderDate } from "../../../formatting/dateFormat";
import { ExpandButton } from "../../../components/datagrid/components/ExpandButton";

export const columns: GridColDef[] = [
  {
    field: "expand",
    headerName: "",
    description: "",
    width: 50,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    renderCell: (params) => {
      return <ExpandButton rowId={params.id} />;
    },
  },
  {
    field: "product.msku",
    headerName: "MSKU",
    description: "Merchant SKU",
    valueGetter: (value, row) => row.product?.msku,
  },
  {
    field: "product.product_title",
    headerName: "Title",
    description: "Product Title",
    valueGetter: (value, row) => row.product?.product_title,
  },
  {
    field: "amazon_listings.asin",
    headerName: "ASIN",
    description: "Amazon Standard Identification Number",
    valueGetter: (value, row) => row.amazon_listings?.asin,
  },
  {
    field: "product.fnsku",
    headerName: "FNSKU",
    description: "Fulfillment Network SKU",
    valueGetter: (value, row) => row.product?.fnsku,
  },
  {
    field: "product.stock",
    headerName: "Stock",
    description: "Current Stock Level",
    type: "number",
    valueGetter: (value, row) => row.product?.stock,
  },
  {
    field: "product.status",
    headerName: "Status",
    description: "Product Status",
    valueGetter: (value, row) => row.product?.status,
  },
  {
    field: "product.last_order_price",
    headerName: "Last Order Price",
    description: "Price of Last Order",
    type: "number",
    valueGetter: (value, row) => row.product?.last_order_price,
  },
  {
    field: "product.last_order_qty",
    headerName: "Last Order Qty",
    description: "Quantity of Last Order",
    type: "number",
    valueGetter: (value, row) => row.product?.last_order_qty,
  },
  {
    field: "product.inbound_inventory",
    headerName: "Inbound Inventory",
    description: "Inbound Inventory Count",
    type: "number",
    valueGetter: (value, row) => row.product?.inbound_inventory,
  },
  {
    field: "product.ship_stock",
    headerName: "Ship Stock",
    description: "Shippable Stock",
    type: "number",
    valueGetter: (value, row) => row.product?.ship_stock,
  },
  {
    field: "product.inv_age_271_to_365",
    headerName: "Aged 271-365 Days",
    description: "Inventory Aged 271-365 Days",
    type: "number",
    valueGetter: (value, row) => row.product?.inv_age_271_to_365,
  },
  {
    field: "product.alert",
    headerName: "Alert",
    description: "Product Alert Status",
    valueGetter: (value, row) => row.product?.alert,
  },
  {
    field: "product.fba_sell_through",
    headerName: "FBA Sell Through",
    description: "FBA Sell Through Rate",
    type: "number",
    valueGetter: (value, row) => row.product?.fba_sell_through,
  },
  {
    field: "product.total_sales",
    headerName: "Total Sales",
    description: "Total Sales Amount",
    type: "number",
    valueGetter: (value, row) => row.product?.total_sales,
  },
  {
    field: "product.90_day_sales",
    headerName: "90 Day Sales",
    description: "90 Day Sales Amount",
    type: "number",
    valueGetter: (value, row) => row.product?.["90_day_sales"],
  },
  {
    field: "product.30_day_sales",
    headerName: "30 Day Sales",
    description: "30 Day Sales Amount",
    type: "number",
    valueGetter: (value, row) => row.product?.["30_day_sales"],
  },
  {
    field: "product.7_day_sales",
    headerName: "7 Day Sales",
    description: "7 Day Sales Amount",
    type: "number",
    valueGetter: (value, row) => row.product?.["7_day_sales"],
  },
  {
    field: "product.price",
    headerName: "Listing Price",
    description: "Current Listing Price",
    type: "number",
    valueGetter: (value, row) => row.product?.price,
  },
  {
    field: "product.30_day_profit",
    headerName: "30 Day Profit",
    description: "30 Day Profit",
    type: "number",
    valueGetter: (value, row) => row.product?.["30_day_profit"],
  },
  {
    field: "amazon_listings.total_sales",
    headerName: "Listing Total Sales",
    description: "Listing Total Sales",
    type: "number",
    valueGetter: (value, row) => row.amazon_listings?.total_sales,
  },
  {
    field: "amazon_listings.365_day_sales",
    headerName: "365 Day Sales",
    description: "365 Day Sales Amount",
    type: "number",
    valueGetter: (value, row) => row.amazon_listings?.["365_day_sales"],
  },
  {
    field: "amazon_listings.90_day_sales",
    headerName: "Listing 90 Day Sales",
    description: "Listing 90 Day Sales Amount",
    type: "number",
    valueGetter: (value, row) => row.amazon_listings?.["90_day_sales"],
  },
  {
    field: "amazon_listings.30_day_sales",
    headerName: "Listing 30 Day Sales",
    description: "Listing 30 Day Sales Amount",
    type: "number",
    valueGetter: (value, row) => row.amazon_listings?.["30_day_sales"],
  },
  {
    field: "amazon_listings.7_day_sales",
    headerName: "Listing 7 Day Sales",
    description: "Listing 7 Day Sales Amount",
    type: "number",
    valueGetter: (value, row) => row.amazon_listings?.["7_day_sales"],
  },
  {
    field: "amazon_product_pricing_info.sales_rank",
    headerName: "Sales Rank",
    description: "Product Sales Rank",
    type: "number",
    valueGetter: (value, row) => row.amazon_product_pricing_info?.sales_rank,
  },
  {
    field: "amazon_product_pricing_info.product_category",
    headerName: "Category",
    description: "Product Category",
    valueGetter: (value, row) =>
      row.amazon_product_pricing_info?.product_category,
  },
  {
    field: "amazon_product_pricing_info.holds_buy_box",
    headerName: "Holds Buy Box",
    description: "Holds Buy Box",
    type: "boolean",
    valueGetter: (value, row) => row.amazon_product_pricing_info?.holds_buy_box,
  },
  {
    field: "amazon_product_pricing_info.buy_box_price",
    headerName: "Buy Box Price",
    description: "Buy Box Price",
    type: "number",
    valueGetter: (value, row) => row.amazon_product_pricing_info?.buy_box_price,
  },
  {
    field: "amazon_product_pricing_info.buy_box_info",
    headerName: "Buy Box Info",
    description: "Buy Box Information",
    valueGetter: (value, row) => row.amazon_product_pricing_info?.buy_box_info,
  },
  {
    field: "product.purchasable_stock",
    headerName: "Purchasable Stock",
    description: "Purchasable Stock Count",
    type: "number",
    valueGetter: (value, row) => row.product?.purchasable_stock,
  },
  {
    field: "amazon_listings.last_non_cancelled_order_timestamp",
    headerName: "Last Order Date",
    description: "Last Non-Cancelled Order Timestamp",
    type: "dateTime",
    valueGetter: (value, row) =>
      row.amazon_listings?.last_non_cancelled_order_timestamp,
    valueFormatter: (value) => renderDate(value),
  },
];
